"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const io_1 = require("react-icons/io");
const UtilisateursAdminTable_1 = __importDefault(require("./Tables/UtilisateursAdminTable"));
const fa6_1 = require("react-icons/fa6");
const axios_1 = __importDefault(require("axios"));
const hook_1 = require("../../../redux/hook");
const UtilisateursAdmin = () => {
    const [search, setSearch] = (0, react_1.useState)("");
    const [selectedCategory, setSelectedCategory] = (0, react_1.useState)("");
    const [isLoading2, setIsLoading2] = (0, react_1.useState)(false);
    const { token } = (0, hook_1.useAppSelector)((state) => state.user);
    const exportUtilisateurs = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading2(true);
        try {
            const response = yield axios_1.default.get(`/api/v1/app/exportMobileUsers`, {
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            const resp = response.data;
            if (resp.success) {
                const fileUrl = resp.file_url;
                const fullFileName = fileUrl.split("/").pop() || "export.xlsx";
                const baseName = fullFileName.replace(/\.[^/.]+$/, "");
                const link = document.createElement("a");
                link.href = fileUrl;
                link.setAttribute("target", "_blank");
                link.setAttribute("download", `${baseName}.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        }
        catch (error) {
            console.log(error);
        }
        finally {
            setIsLoading2(false);
        }
    });
    return (react_1.default.createElement("div", { className: "dashbord-admin-component" },
        react_1.default.createElement("div", { className: "dash-admin-page-content-container mb-3" },
            react_1.default.createElement("div", { className: "container-fluid" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "col-lg-12" },
                        react_1.default.createElement("div", { className: "sub-title-page-admin pb-3" }, "Utilisateurs"),
                        react_1.default.createElement("div", { className: "row mt-5" },
                            react_1.default.createElement("div", { className: "col-lg-12 sunu-autoroute-admin-titre-page-container mb-3" },
                                react_1.default.createElement("div", { className: "admin-titre-page" }, "Utilisateurs"),
                                react_1.default.createElement("div", { className: "sunu-autoroute-admin-btn-add-container" },
                                    react_1.default.createElement("button", { className: "sunu-autoroute-admin-btn-import", onClick: exportUtilisateurs },
                                        react_1.default.createElement(fa6_1.FaFileExport, null),
                                        isLoading2 ? "En cours.." : 'Exporter les utilisateurs')))),
                        react_1.default.createElement("div", { className: "row mb-4" },
                            react_1.default.createElement("div", { className: "col-lg-12" },
                                react_1.default.createElement("div", { className: "pb-4 search-group-wrapper" },
                                    react_1.default.createElement("div", { className: "search-form-group position-relative" },
                                        react_1.default.createElement("span", { className: "search-input-icon" },
                                            react_1.default.createElement(io_1.IoMdSearch, null)),
                                        react_1.default.createElement("input", { type: "search", className: "form-control search-form-control", id: "search", "aria-label": "UsernSearchame", placeholder: "Rechercher...", value: search, onChange: (e) => setSearch(e.target.value) }))),
                                react_1.default.createElement("div", { className: "table--wrapper admin-table--wrapper" },
                                    react_1.default.createElement(UtilisateursAdminTable_1.default, { search: search, selectedCategory: selectedCategory }))))))))));
};
exports.default = UtilisateursAdmin;
